import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 19.68 13.38",
  "content": "<symbol viewBox=\"0 0 19.68 13.38\" id=\"icon-menu\">\r\n    <path d=\"M19.68,12.2a1.17,1.17,0,0,1-1.18,1.18H1.18a1.18,1.18,0,1,1,0-2.36H18.5A1.18,1.18,0,0,1,19.68,12.2Z\" />\r\n    <path d=\"M19.68,6.69A1.18,1.18,0,0,1,18.5,7.87H1.18a1.18,1.18,0,1,1,0-2.36H18.5A1.18,1.18,0,0,1,19.68,6.69Z\" />\r\n    <path d=\"M19.68,1.18A1.18,1.18,0,0,1,18.5,2.36H1.18A1.18,1.18,0,1,1,1.18,0H18.5A1.18,1.18,0,0,1,19.68,1.18Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/menu.svg
// module id = ./app/general/svg/menu.svg
// module chunks = app